import React from 'react';

const partners = [
  { name: 'UNDP',             src: 'img/partners/undp-logo.jpg' },
  { name: 'GIZ',              src: 'img/partners/giz-logo.png' },
  { name: 'European Union',   src: 'img/partners/european-union-logo.jpg' },
  { name: 'STG',              src: 'img/partners/stg-logo.png' },
  { name: 'PHGEX',            src: 'img/partners/phgex-logo.png' },
  { name: 'Community Connect',src: 'img/partners/community-connect-logo.jpg' },
  { name: 'AMREF Africa',     src: 'img/partners/amref-africa.jpg' },
  { name: 'Vision Spring',    src: 'img/partners/vision-spring.jpg' },
];

// Duplicate the list so the marquee loops seamlessly
const track = [...partners, ...partners];

const styles = {
  section: {
    padding: '60px 0 50px',
    background: '#f8faff',
    borderTop: '1px solid #e8edf5',
    borderBottom: '1px solid #e8edf5',
    overflow: 'hidden',
  },
  header: {
    textAlign: 'center',
    marginBottom: '36px',
  },
  eyebrow: {
    display: 'inline-block',
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    color: '#19409a',
    marginBottom: '10px',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 12px',
  },
  divider: {
    width: '52px',
    height: '3px',
    background: 'linear-gradient(90deg, #19409a, #00d1f9)',
    borderRadius: '2px',
    margin: '0 auto',
  },
  marqueeWrapper: {
    position: 'relative',
  },
  fadeLeft: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '100px',
    background: 'linear-gradient(to right, #f8faff, transparent)',
    zIndex: 2,
    pointerEvents: 'none',
  },
  fadeRight: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '100px',
    background: 'linear-gradient(to left, #f8faff, transparent)',
    zIndex: 2,
    pointerEvents: 'none',
  },
  track: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    width: 'max-content',
    animation: 'partners-marquee 30s linear infinite',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#ffffff',
    borderRadius: '12px',
    padding: '18px 28px',
    minWidth: '190px',
    height: '120px',
    boxShadow: '0 2px 12px rgba(25, 64, 154, 0.07)',
    border: '1px solid #e8edf5',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'default',
    flexShrink: 0,
  },
  img: {
    maxWidth: '160px',
    maxHeight: '80px',
    objectFit: 'contain',
    filter: 'grayscale(40%)',
    transition: 'filter 0.3s ease',
  },
};

const PartnersSlider = () => {
  return (
    <section style={styles.section}>
      {/* Keyframe injection */}
      <style>{`
        @keyframes partners-marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .partner-card:hover {
          transform: translateY(-4px) !important;
          box-shadow: 0 8px 28px rgba(25, 64, 154, 0.14) !important;
        }
        .partner-card:hover img {
          filter: grayscale(0%) !important;
        }
      `}</style>

      {/* Section Header */}
      <div style={styles.header}>
        <span style={styles.eyebrow}>Trusted By</span>
        <h2 style={styles.title}>Our Partners &amp; Collaborators</h2>
        <div style={styles.divider}></div>
      </div>

      {/* Marquee */}
      <div style={styles.marqueeWrapper}>
        <div style={styles.fadeLeft}></div>
        <div style={styles.fadeRight}></div>

        <div style={styles.track}>
          {track.map((partner, index) => (
            <div
              key={index}
              className="partner-card"
              style={styles.card}
              title={partner.name}
            >
              <img
                src={partner.src}
                alt={partner.name}
                style={styles.img}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSlider;